import { Api } from "./Api";
import axios from "axios";
import { BulletinDeSalaire } from "../models/BulletinDeSalaire";
import FileUtils from "../utils/FileUtils";
import _ from "lodash";

export class BulletinDeSalaireApi extends Api {
    constructor() {
        super("document/bulletin-de-salaire");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<BulletinDeSalaire> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (b) {
                    return new BulletinDeSalaire(b);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<BulletinDeSalaire> {
        return this.getResource(id, params).then(function (response) {
            return new BulletinDeSalaire(response.data.data);
        });
    }

    save(
        bulletinDeSalaire: BulletinDeSalaire,
        params?: Object
    ): Promise<BulletinDeSalaire> {
        return super
            .saveResource(bulletinDeSalaire.serialize(), params)
            .then(function (response) {
                return new BulletinDeSalaire(response.data.data);
            });
    }

    delete(id: Number, raison: string): Promise<BulletinDeSalaire> {
        return super.deleteResource(id, raison).then(function (response) {
            return new BulletinDeSalaire(response.data.data);
        });
    }

    /**
     * Télécharge le PDF d'un bulletin. L'endpoint est protégé par JWT : on
     * passe par axios (qui porte l'en-tête Authorization) et un blob, un lien
     * nu étant envoyé par le navigateur sans en-tête.
     */
    downloadPdf(id: Number): Promise<void> {
        return axios
            .get(`${this.apiUrl}${id}/pdf`, { responseType: "blob" })
            .then(function (response) {
                const disposition =
                    response.headers["content-disposition"] || "";
                const match = disposition.match(/filename="?([^";]+)"?/);
                FileUtils.downloadBlob(
                    response.data,
                    match ? match[1] : `bulletin-de-salaire-${id}.pdf`
                );
            });
    }

    importExcel(file: File, month: string): Promise<any> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("month", month);

        return axios.post(`${this.apiUrl}import-excel`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }
}
